<template>
  <section
    id="productProperty"
  >
    <template v-if="categoryAttributes.length > 0">
      <div
        class="row"
        v-for="(attribute, index) in categoryAttributes"
        :key="index"
      >
        <label class="label">
          {{ attribute.name }}
          <span
            class="required"
            v-if="attribute.validation && (attribute.validation.required || attribute.validation.requiredSelect)"
          >
            *
          </span>
        </label>
        <DynamicInput
          :attr="attribute"
          :class="{'is-invalid' : errors.has(attribute.props.name), 'form-control': attribute.className}"
          v-validate="attribute.validation"
          data-vv-validate-on="change|input"
          v-model="product.attrs[attribute.id]"
        />
        <div class="invalid-feedback">
          {{ errors.first(attribute.props.name) }}
        </div>
      </div>
    </template>
  </section>
</template>
<script>
import categoryService from '@/services/category';
import DynamicInput from '@/components/DynamicInput';
export default {
  name: 'ProductProperty',
  components: { DynamicInput },
  props: {
    product: {
      type: Object,
      default: () => {},
    },
  },
  data () {
    return {
      categoryAttributes: [],
    };
  },
  methods: {
    async getCategoryAttributes () {
      this.categoryAttributes = [];
      const attributes = await categoryService.getCategoryAttributes(this.product.pimCategoryId);
      const categoryAttrs = [];
      const disabledValidationAttrs = [];

      this.product.attrs = {};

      attributes.categoryAttributes = attributes.categoryAttributes || [];
      for (let i = 0; i < attributes.categoryAttributes.length; i += 1) {
        const attr = attributes.categoryAttributes[i];

        const field = {
          id: attr.attribute.id,
          name: attr.attribute.name,
          validation: { required: attr.required },
          varianter: attr.varianter,
          slicer: attr.slicer,
          inputType: attr.allowCustom && attr.attributeValues.length === 0 ? 'input' : 'Select',
          className: attr.allowCustom,
          props: {
            name: `field-${attr.attribute.id}`,
            'data-vv-as': attr.attribute.name,
            disabled: this.product.approved && (attr.varianter || attr.slicer),
          },
        };
        if (attr.attribute.id === 47) {
          field.inputType = 'input';
          field.validation.max = 50;
        }

        if (!attr.allowCustom) {
          field.validation = { requiredSelect: attr.required };
          field.props.searchable = true;
          field.props.options = attr.attributeValues.map(val => ({
            id: val.id,
            label: val.name,
          }));
        }

        const selectedAttr = this.product.attributes.filter((item) => item.attributeName === attr.attribute.name);
        if (selectedAttr.length) {
          this.product.attrs[attr.attribute.id] = selectedAttr[0].attributeValue;
          if (!attr.allowCustom && field.props.options.length) {
            const selectedOptions = field.props.options.filter((option) => {
              return option.label === selectedAttr[0].attributeValue ||
                option.id === selectedAttr[0].attributeValueId;
            });
            this.product.attrs[attr.attribute.id] = {
              id: selectedOptions.length ? selectedOptions[0].id : null,
              label: selectedOptions.length ? selectedOptions[0].label : null,
            };
          }
        }
        if (field.props.disabled && attr.required) {
          delete field.validation;
          disabledValidationAttrs.push(attr.attribute.id);
        }
        categoryAttrs.push(field);
      }
      this.categoryAttributes = categoryAttrs;
      await this.$nextTick();
      this.setTabOffset();
      this.$emit('setDisabledValidationAttrs', disabledValidationAttrs);
    },
    setTabOffset () {
      this.$emit('setTabOffset');
    },
    async validate () {
      const isValid = await this.$validator.validateAll();
      return isValid;
    },
  },
  async created () {
    this.getCategoryAttributes();
  },
  watch: {
    'product.pimCategoryId': function () {
      this.getCategoryAttributes();
    },
  },
};
</script>
